import { render } from "./ViewJobDocument.vue?vue&type=template&id=1ff7f31a"
import script from "./ViewJobDocument.vue?vue&type=script&lang=js"
export * from "./ViewJobDocument.vue?vue&type=script&lang=js"

import "./ViewJobDocument.vue?vue&type=style&index=0&id=1ff7f31a&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__